export const getYearRange = (maximumYear: number, minimumYear: number) => {
	let startYear = minimumYear;
	const years = [];

	while (startYear <= maximumYear) {
		years.push(startYear++);
	}

	return years;
};